import axios from "./axios";

export const baseURL = "/api";

export const URL = {
  GENAUTH_CODE:"/genAuthCode",
  LOGIN:"/userLogin",
  LOGOUT:"/userLogout",
  WALLET_BILL:"/website/bill",
  WALLET_BALANCE:"/website/balance",
  WALLET_ORDERS:"/website/orders",
  VOLUMN_PERTIME_SLOT:"/market/volumnPerTimeslot",
  CREATE_WITHDRAW:"/website/createWithdraw",
  GET_24HR:"/market/ticker/24hr",
  GET_KLINE:"/market/kLine",
  SHOW_DEPOSIT:"/website/showDeposit",
  CREATE_ORDER:"/website/createOrder",
  ORDER_RECORD:"/website/orders"
}

//获取验证码
export function genAuthCodeFetch(data){
  return axios.post(baseURL+URL.GENAUTH_CODE,data)
}

export function loginFetch(data){
  return axios.post(baseURL+URL.LOGIN,data)
}

export function logoutFetch(){
  return axios.post(baseURL+URL.LOGOUT)
}

//获取钱包账单
export function walletBill(data){
  return axios.post(baseURL+URL.WALLET_BILL,data)
}

//钱包余额
export function walletBalance(){
  return axios.post(baseURL+URL.WALLET_BALANCE)
}

//获取前台订单记录
export function walletOrders(){
  return axios.post(baseURL+URL.WALLET_ORDERS)
}

//提现接口
export function createWithdraw(data){
  return axios.post(baseURL + URL.CREATE_WITHDRAW,data)
}

//获取24小时价格
export function get24hr(data){
  return axios.post(baseURL + URL.GET_24HR,data)
}

//获取K线图数据
export function getKline(data){
  return axios.post(baseURL+URL.GET_KLINE,data)
}

//获取最近交易
export function volumnPerTimeslot(data){
  return axios.post(baseURL+URL.VOLUMN_PERTIME_SLOT,data)
}

//获取二维码
export function getDeposit(){
  return axios.post(baseURL+URL.SHOW_DEPOSIT)
}

//创建订单
export function createOrder(data){
  return axios.post(baseURL+URL.CREATE_ORDER,data)
}


//创建订单
export function getOrderRecord(data){
  return axios.post(baseURL+URL.ORDER_RECORD,data)
}